import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const currentUser = JSON.parse(localStorage.getItem('user')!);

      if (currentUser?.token) {
        return true;   // Logged in so Return True
      }

      // Not Logged in, So Rediect to Login Page with return Url
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl:state.url } });
    return false;
  }
  
}
